<template>
  <div class="table-home-wrap">
    <BigPreloader
      v-if="isTableLoading"
      :caption="$t('table.table_home.preloader.caption')"
      :info="$t('table.table_home.preloader.info')"
    />
    <template v-else>
      <TabPlaceholder
        v-if="searchText.length && !categories.value.length"
        :caption="$t('table.table_home.notFound.caption')"
        :info="$t('table.table_home.notFound.caption', { searchText })"
        :emoji="notFoundEmoji"
      />
      <div v-else class="main-table-wrap">
        <new-context-toolbar :isPatternView.sync="localIsPatternView" />
        <TableHeader :isPatternView="localIsPatternView" />
        <TabPlaceholder
          v-if="categories && !categories.value.length"
          :caption="$t('table.table_home.emptyPatternView.caption')"
          :info="$t('table.table_home.emptyPatternView.info')"
        />
        <TableMain
          v-else
          :isPatternView="localIsPatternView"
          :search-text="searchText"
        />
      </div>
    </template>
  </div>
</template>

<script>
import notificationEmojies from '@/modules/notification-emojies.mapping'
import { mapState, mapGetters, mapMutations } from 'vuex'
import BigPreloader from '@/components/common/BigPreloader'
import TabPlaceholder from '@/components/common/TabPlaceholder'
import newContextToolbar from '@/components/common/context/context_new_toolbar'
import TableMain from './table_main'
import TableHeader from './table_header'

export default {
  components: {
    BigPreloader,
    TabPlaceholder,
    newContextToolbar,
    TableMain,
    TableHeader
  },

  props: {
    searchText: String
  },

  methods: {
    ...mapMutations('knowledgebase/patterns', ['SET_IS_PATTERN_VIEW'])
  },

  computed: {
    ...mapState('knowledgebase', ['categories']),
    ...mapState('knowledgebase/patterns', ['isPatternView']),
    ...mapGetters('knowledgebase', ['isTableLoading']),

    notFoundEmoji () {
      return notificationEmojies.notFound
    },

    localIsPatternView: {
      get () {
        return this.isPatternView
      },
      set (value) {
        this.SET_IS_PATTERN_VIEW(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-home-wrap {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 32px);

  -ms-overflow-style: none;

  .main-table-wrap {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    flex-grow: 1;
  }
}
</style>
